<template>
  <view class="button-groupwith-context-demo">
    <cube-button-group direction="horizontal">
      <view class="button-groupwith-title">图文结合示例</view>
      <cube-button inline>操作</cube-button>
    </cube-button-group>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    addGlobalClass: true,
    styleIsolation: 'shared'
  }
})
</script>

<style lang="stylus">
.button-groupwith-context-demo
  .cube-button-group
    display flex
    padding 20px 25px
    box-sizing border-box
    background-color #fff
    justify-content space-between
    align-items center
    border-radius 8px
  .button-groupwith-title
    line-height 27px
    font-size 21px
    color #282828
  .cube-btn
    padding 8px 26px
    font-size 16px
    line-height 24px
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "usingComponents": {
      "view-desc": "../../components/desc/index",
      "cube-button-group": "@mpxjs/mpx-cube-ui/src/components/button-group/index",
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index"
    }
  }
</script>
